export default {
  AMARELO: '#FFEF52;',
  AZUL: '#00273F',
  AZUL_CLARO: '#97C0E2',
  BRANCO: '#FFFFFF',
  CINZA: '#D2D0D0',
  CINZA_ESCURO: '#ADADAD',
  VERMELHO: '#FF0000',
  VERDE: '#97E298',
  VERDE_ESCURO: '#009900',
  CARDS_COLLORS: ['#6BE6C2', '#EFF36F', '#F28C5C', '#5C65F2'],
};
